import React from "react";
import styles from "./SHProducts.module.scss";

const SEARCH_TIPS = [
  "Try searching by product type, brand, item # or product feature.",
  "Check your spelling.",
  "Broaden your search by using fewer or more general words.",
];

export const NoProducts = ({ search, divisions = [], successMessage, loading, onEmail, onBrowse }) => {
  return (
    <div>
      <p className={styles.result_hint}>Your Search for "{search}" didn't return any results</p>
      <div className={styles.detail_view}>
        {SEARCH_TIPS.length > 0 && (
          <div className={styles.section}>
            <h4 className={styles.section_title}>Search Tips</h4>
            {SEARCH_TIPS.map((line, idx) => (
              <p key={idx} className={styles.section_text}>
                - {line}
              </p>
            ))}
          </div>
        )}

        {divisions.length > 0 && (
          <div className={styles.section}>
            <h4 className={styles.section_title}>Browse By Category</h4>
            <div className={styles.button_container}>
              {divisions.map(({ key, value }) => (
                <button key={key} type="button" className={styles.back_link} onClick={() => onBrowse(key)}>
                  {value}
                </button>
              ))}
            </div>
          </div>
        )}

        <div className={styles.section}>
          <h4 className={styles.section_title}>Need Help?</h4>
          {successMessage && (
            <div className={styles.successBanner}>
              <div>Thank you for reaching out to us!</div>
              <div>{successMessage}</div>
            </div>
          )}
          <div className={styles.contactOption} role="button" onClick={onEmail}>
            <i className="fa fa-envelope" aria-hidden="true"></i>
            {loading && <span data-testid="loading-spinner" className={styles.custom_spinner}></span>}
            <span>Request more info</span>
          </div>
        </div>
      </div>
    </div>
  );
};
